const changeSideBar = (value) => ({
  type: "CHANGE_SIDEBAR",
  payload: value,
});

export { changeSideBar };
